import type { Company } from '../company.types';
import dayjs from 'dayjs';

export class CompanySimpleModel {
  private readonly _dto: Company;

  constructor(dto: Company) {
    this._dto = dto;
  }

  get originDTO(): Company {
    return this._dto;
  }

  get id(): CompanyId {
    return this._dto.id;
  }

  get name(): string {
    return this._dto.name || '';
  }

  get type(): string {
    return this._dto.type || 'CO_CORPORATION';
  }

  get email(): string | undefined {
    return this._dto.email;
  }

  get phone(): string | undefined {
    return this._dto.phone;
  }

  get url(): string | undefined {
    return this._dto.url;
  }

  get address(): string | undefined {
    return this._dto.address;
  }

  get businessRegistrationNumber(): string | undefined {
    return this._dto.businessRegistrationNumber;
  }

  get corporateRegistrationNumber(): string | undefined {
    return this._dto.corporateRegistrationNumber;
  }

  get industry(): string | undefined {
    return this._dto.industry;
  }

  get shippingAddress(): string | undefined {
    return this._dto.shippingAddress;
  }

  get companyRepresentative(): string | undefined {
    return this._dto.companyRepresentative;
  }

  get createdAt(): string | undefined {
    return this._dto.createdDate ? dayjs(this._dto.createdDate).format('YYYY-MM-DD HH:mm') : undefined;
  }

  get updatedAt(): string | undefined {
    return this._dto.updatedDate ? dayjs(this._dto.updatedDate).format('YYYY-MM-DD HH:mm') : undefined;
  }
}
